import React from 'react';

import './style.scss';

const CardStatus = ({ icon, styleIcon, title, value, color }) => {
  return (
    <div className="card-realtime">
      <img src={icon} alt={title} style={styleIcon} />
      <div className="divider" />
      <div className="card-text">
        <h6>{title}</h6>
        <span style={{ color }}>{value}</span>
      </div>
    </div>
  );
};

export default CardStatus;
